import React from 'react';
import ThemeContext from '@/uptk/core/packages/theme/ThemeContext';

type ThemeProviderProps = {
  children?: React.ReactNode;
  theme?: unknown;
};

const ThemeProvider = ({ children, theme }: ThemeProviderProps) =>
  React.createElement(ThemeContext.Provider, { value: theme }, children);

export default ThemeProvider;
